/*=========================================================================================
	File Name: actions.js
	Description: Vuex Store - actions
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "axios";
import Vue from "vue";
import Crypto from "@/helper/crypto";
import { resolve } from "core-js/fn/promise";

const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit("UPDATE_STARRED_PAGE", payload);
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_LIMITED", list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_MORE", list);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit("TOGGLE_CONTENT_OVERLAY");
  },
  toggleDarkMode({ commit }) {
    commit("TOGGLE_DARK_MODE");
  },
  updateTheme({ commit }, val) {
    commit("UPDATE_THEME", val);
  },
  updateSelectedHelpCenter({ commit }, val) {
    commit("UPDATE_SELECTED_HELP_CENTER", val);
  },
  updateHelpCenterCustomizer({ commit }, val) {
    commit("UPDATE_HELP_CENTER_CUSTOMIZER", val);
  },
};

export default actions;
